import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { DemoProvider } from "@/store/DemoStore";
import { TopNav } from "@/components/TopNav";
import { EventChatbot } from "@/components/EventChatbot";
import { InstallPrompt } from "@/components/InstallPrompt";
import Landing from "@/pages/Landing";
import PublicRegistration from "@/pages/PublicRegistration";
import MemberPortal from "@/pages/MemberPortal";
import TableLeader from "@/pages/TableLeader";
import Scanner from "@/pages/Scanner";
import ReceptionDesk from "@/pages/ReceptionDesk";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminDashboard from "@/pages/AdminDashboard";
import Statistics from "@/pages/admin/Statistics";
import Voice from "@/pages/admin/Voice";
import Conclave from "@/pages/admin/Conclave";
import Payouts from "@/pages/admin/Payouts";
import AdminRecap from "@/pages/admin/Recap";
import ChatInsights from "@/pages/admin/ChatInsights";
import SoftLaunchMonitor from "@/pages/admin/SoftLaunchMonitor";
import AdminRegistrations from "@/pages/admin/AdminRegistrations";
import AdminDirectory from "@/pages/admin/AdminDirectory";
import DevAdmin from "@/pages/DevAdmin";
import Recap from "@/pages/Recap";
import BigScreen from "@/pages/BigScreen";
import BigScreenKioskSetup from "@/pages/BigScreenKioskSetup";

function ConditionalNav() {
  const { pathname } = useLocation();
  // Hide the default dark demo nav on printable recap, the venue big-screen view,
  // and the marketing /register page (which renders its own light editorial nav).
  if (
    pathname.startsWith("/recap/") ||
    pathname === "/big-screen" ||
    pathname === "/" ||
    pathname === "/register" ||
    pathname.startsWith("/admin")
  ) return null;
  return <TopNav />;
}

function App() {
  React.useEffect(() => {
    document.title = "BNI - Members Day - Davangere";
    // Ensure favicon points at our BNI logo, even if a runtime script swaps it
    const ensureIcon = () => {
      const href = "/favicon.png";
      let link = document.querySelector('link[rel="icon"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.type = "image/png";
      link.href = href;
      let apple = document.querySelector('link[rel="apple-touch-icon"]');
      if (!apple) {
        apple = document.createElement("link");
        apple.rel = "apple-touch-icon";
        document.head.appendChild(apple);
      }
      apple.href = href;
    };
    ensureIcon();
    // Re-apply after a tick in case an external script overrides on load
    const t1 = setTimeout(() => { document.title = "BNI - Members Day - Davangere"; ensureIcon(); }, 500);
    const t2 = setTimeout(() => { document.title = "BNI - Members Day - Davangere"; ensureIcon(); }, 2000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <DemoProvider>
          <ConditionalNav />
          <Routes>
            <Route path="/" element={<PublicRegistration />} />
            <Route path="/walkthrough" element={<Landing />} />
            <Route path="/register" element={<PublicRegistration />} />
            <Route path="/member" element={<MemberPortal />} />
            <Route path="/leader" element={<TableLeader />} />
            <Route path="/scanner" element={<Scanner />} />
            <Route path="/reception" element={<ReceptionDesk />} />
            <Route path="/success/:regId" element={<PaymentSuccess />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/statistics" element={<Statistics />} />
            <Route path="/admin/voice" element={<Voice />} />
            <Route path="/admin/conclave" element={<Conclave />} />
            <Route path="/admin/payouts" element={<Payouts />} />
            <Route path="/admin/recap" element={<AdminRecap />} />
            <Route path="/admin/chat-insights" element={<ChatInsights />} />
            <Route path="/admin/soft-launch" element={<SoftLaunchMonitor />} />
            <Route path="/admin/registrations" element={<AdminRegistrations />} />
            <Route path="/admin/directory" element={<AdminDirectory />} />
            <Route path="/devadmin" element={<DevAdmin />} />
            <Route path="/recap/:id" element={<Recap />} />
            <Route path="/big-screen" element={<BigScreen />} />
            <Route path="/big-screen/kiosk-setup" element={<BigScreenKioskSetup />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <EventChatbot />
          <InstallPrompt />
        </DemoProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
